// extracted by mini-css-extract-plugin
export var accent = "_af-4";
export var add = "_af-j";
export var addIcon = "_af-k";
export var deleteIcon = "_af-i";
export var disabled = "_af-9";
export var ellipsis = "_af-f";
export var error = "_af-3";
export var form = "_af-5";
export var hideFocus = "_af-2";
export var icon = "_af-7";
export var input = "_af-e";
export var listItem = "_af-h";
export var mediumHeight = "_af-b";
export var noBorder = "_af-8";
export var noRadius = "_af-1";
export var shortHeight = "_af-a";
export var tallHeight = "_af-c";
export var textInput = "_af-0";
export var vertical = "_af-g";
export var veryTallHeight = "_af-d";
export var widget = "_af-6";